import Nullstack from 'nullstack';
import ArticleGrid from '../layout/ArticleGrid';

class Articles extends Nullstack {

  static hash = '6a695c93d6f3f622c38369fc89a5ce0a';

  static getLatestArticles = Nullstack.invoke('getLatestArticles', '6a695c93d6f3f622c38369fc89a5ce0a');

  async initiate() {
    this.articles = await this.getLatestArticles();
  }

  render() {
    return (
      <section class="max-w-screen-xl mx-auto px-4">
        <h3 class="mb-10 text-center text-2xl md:text-5xl font-bold text-tips-dark text-opacity-80 md:mb-24 ">Últimas do Blog</h3>
        <ArticleGrid articles={this.articles} />
      </section>
    );
  }

}

export default Articles;
if (module.hot) { module.hot.accept(); Nullstack.updateInstancesPrototypes(Articles, Articles.hash, '2766ea6aafd9db34520f66d1e96658a5') }